import { EventRole } from '../interfaces/event';

import { CheckIsAdminRoleType } from './interfaces';

export const checkIsAdminRole: CheckIsAdminRoleType = (role) =>
  role === EventRole.Admin;
